import request from "@/utils/request"

export function getNoticeContent(id) {
  return request.post("/notice/detail", { noticeId: id})
}